import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-8d4a650a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "buhuo"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "username"
};
const _hoisted_4 = {
  style: {
    "float": "right",
    "margin-bottom": "3px"
  }
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("自动补货变更记录");

const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  class: "dialog-title"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自动补货变更记录", -1));

const _hoisted_10 = /*#__PURE__*/_createTextVNode("关闭");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");

  const _component_el_select = _resolveComponent("el-select");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_pagination = _resolveComponent("el-pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [!$data.dialog.visible ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.userinfo.username), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_select, {
    modelValue: $data.game_id,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.game_id = $event),
    size: "small",
    placeholder: "请选择",
    onChange: $options.game_change
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.game_list, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.id,
        label: item.gname,
        value: item.id
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"]), _createVNode(_component_el_button, {
    style: {
      "margin-left": "5px"
    },
    size: "small",
    icon: "search",
    onClick: _withModifiers($options.get_buhuo_log, ["prevent"])
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }, 8, ["onClick"])])]), _createVNode(_component_el_table, {
    data: $data.buhuo_data,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      property: "name",
      label: "补货类型",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "let_type",
      label: "计算方式",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.let_type == '1' ? (_openBlock(), _createElementBlock("span", _hoisted_6, "下注额")) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row.let_type), 1))]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "control_let",
      label: "控制额度",
      align: "center"
    })]),
    _: 1
  }, 8, ["data"])], 64)) : _createCommentVNode("", true), $data.dialog.visible ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_button, {
    style: {
      "float": "right"
    },
    size: "small",
    onClick: _cache[1] || (_cache[1] = $event => $data.dialog.visible = false)
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  })]), _createVNode(_component_el_table, {
    data: $data.dialog.list,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      property: "gname",
      label: "彩种类型",
      align: "center",
      width: "100"
    }), _createVNode(_component_el_table_column, {
      property: "write_time",
      label: "变更时间",
      align: "center",
      width: "180"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.$filters.time(scope.row.write_time)), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      property: "remark",
      label: "变更说明",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      property: "old_value",
      label: "原值",
      align: "center",
      width: "80"
    }), _createVNode(_component_el_table_column, {
      property: "new_value",
      label: "新值",
      align: "center",
      width: "80"
    }), _createVNode(_component_el_table_column, {
      property: "operator",
      label: "变更人",
      align: "center",
      width: "120"
    }), _createVNode(_component_el_table_column, {
      property: "ip",
      label: "IP",
      align: "center",
      width: "150"
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_pagination, {
    class: "paging",
    onCurrentChange: $options.change_page,
    modelValue: $data.post_auto.page,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.post_auto.page = $event),
    "page-size": 10,
    "pager-count": 5,
    total: $data.dialog.pagination.total_records * 1,
    layout: "total,prev,pager,next,jumper",
    "prev-text": "上一页",
    "next-text": "下一页",
    "hide-on-single-page": ""
  }, null, 8, ["onCurrentChange", "modelValue", "total"])], 64)) : _createCommentVNode("", true)]);
}